module.exports = __webpack_public_path__ + "ce28297b7f8137d5b50618a4b1ff9bbb.pdf";